import { render } from "./create-partner.vue?vue&type=template&id=666ecc20"
import script from "./create-partner.vue?vue&type=script&lang=js"
export * from "./create-partner.vue?vue&type=script&lang=js"
script.render = render

export default script